/**
 * Currency Utilities for Dirham (Dh) formatting
 * Replaces all AED references with Dh symbol
 */

/**
 * Format amount with Dirham symbol
 * @param {number} amount - The amount to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted currency string with Dh symbol
 */
export const formatCurrency = (amount, decimals = 2) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return `Dh 0.00`;
  }
  return `Dh ${Number(amount).toFixed(decimals)}`;
};

/**
 * Format amount with Dirham symbol and thousands separator
 * @param {number} amount - The amount to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted currency string with Dh symbol and commas
 */
export const formatCurrencyWithCommas = (amount, decimals = 2) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return `Dh 0.00`;
  }
  return `Dh ${Number(amount).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
};

/**
 * Get just the Dirham symbol
 * @returns {string} Dirham symbol
 */
export const getCurrencySymbol = () => {
  return 'Dh';
};

/**
 * Parse currency string to number
 * Removes Dh symbol and converts to number
 * @param {string} currencyString - Currency string like "Dh 100.00"
 * @returns {number} Parsed number
 */
export const parseCurrency = (currencyString) => {
  if (!currencyString) return 0;
  const numStr = currencyString.toString().replace(/[Dh,\s]/g, '');
  return parseFloat(numStr) || 0;
};
